import React from "react";

import ChangeHistoryModal from "../../../components/ChangeHistory";
import { API_ENDPOINTS } from "../../../constant/_constant";

/*
 * Tabs mirror the product form (Product → Variants / Kit → CVs → Attachments →
 * Notes). Keys must match PRODUCT_HISTORY_TABS in
 * backend/controllers/Product/ProductChangeHistoryController.js.
 * The Status Change tab carries the approval lifecycle (products have no status field).
 */
const tabsFor = (productType) => [
  { key: "all", label: "All" },
  { key: "status", label: "Status Change" },
  { key: "general", label: "Product" },
  productType === "kit"
    ? { key: "kit_products", label: "Kit Products" }
    : { key: "variants", label: "Variants" },
  { key: "contract_vehicles", label: "Contract Vehicles" },
  { key: "attachments", label: "Attachments" },
  { key: "notes", label: "Notes" },
];

/**
 * @param {boolean}  show
 * @param {Function} onHide
 * @param {number}   productId   products.id
 * @param {string}   [skuId]     shown in the subtitle
 * @param {string}   [productType]  "kit" swaps the Variants tab for Kit Products
 */
function ProductChangeHistoryModal({ show, onHide, productId, skuId, productType }) {
  return (
    <ChangeHistoryModal
      show={show}
      onHide={onHide}
      title="Change History"
      subtitle={
        skuId ? (
          <>
            SKU: <strong>{skuId}</strong>
          </>
        ) : null
      }
      tabs={tabsFor(productType)}
      endpoint={API_ENDPOINTS.GET_PRODUCT_CHANGE_HISTORY}
      basePayload={{ product_id: productId }}
    />
  );
}

export default ProductChangeHistoryModal;
